import React from "react";
import ComponentHeader from "../Header/ComponentHeader";
import styled from "styled-components";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import { useInView } from "react-intersection-observer";
import { numberWithSpaces, isCurrentYear } from "../../Helpers/CommonHelper";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { device } from "../../Util/Breakpoints";
import {
  HeadingMunicipality,
  FiguresWrapper
} from "../../Util/StyleProps";
import EmptySpace from "../Elements/EmptySpace";
import HighLineChartLine from "../Charts/HighChartLineChart";

const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-family: 'Inter';
  font-weight: 700;
  width: fit-content;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
      padding: 32px 48px;
  }
  
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;

const IncomeContainer = props => {
  const { data, sweden, blockColor, scroll } = props;

  const [ref, inView, entry] = useInView({
    /* Optional options */
    triggerOnce: true,
    threshold: 0.5
  });
  let municipality1 = data[0];
  let municipality2 = data[1];

  let lastYearsIncome = sweden.montelyincome
    ? sweden.montelyincome.values.slice(-1)[0]
    : "(data saknas)";
  let lastYearSweden = sweden.montelyincome
    ? sweden.montelyincome.years.slice(-1).pop()
    : "(Årtal saknas)";

  const noWrapIncome =
    "<span class='text-nowrap'>" +
    numberWithSpaces(lastYearsIncome) +
    "</span>";

  let subText = `I Sverige är den genomsnittliga inkomsten före skatt för personer som är mellan 20 och 64 år  ${noWrapIncome} kronor per månad (${lastYearSweden}).`;

  // Accessibility för personer som är mellan 20 och 64 år 
  const ariaLabel = municipality => {
    let year = municipality.years ? municipality.years.slice(-1).pop() : null;
    return municipality
      ? `I ${municipality.name} kommun ${
          isCurrentYear(municipality.year) ? "är" : "var"
        } den genomsnittliga inkomsten före skatt ${municipality.values
          .slice(-1)
          .pop()} kronor per månad (${year ? "år " + year : "årtal saknas"})`
      : "";
  };

  const Wrapper = styled.div`
      border-radius: 16px;
      background: #FFF;
      padding: 24px 24px 0 24px;
  `;

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px", marginTop: "64px" }} xmlns="http://www.w3.org/2000/svg" width="64" height="50" viewBox="0 0 64 50" fill="none">
        <path d="M11.6667 50C8.44889 50 5.7 48.86 3.42 46.58C1.14 44.3 0 41.5511 0 38.3333V11.6667C0 8.44889 1.14 5.7 3.42 3.42C5.7 1.14 8.44889 0 11.6667 0H51.6667C54.8844 0 57.6333 1.14 59.9133 3.42C62.1933 5.7 63.3333 8.44889 63.3333 11.6667V38.3333C63.3333 41.5511 62.1933 44.3 59.9133 46.58C57.6333 48.86 54.8844 50 51.6667 50H11.6667ZM11.6667 13.1092H51.6667C53.2139 13.1092 54.6583 13.3753 56 13.9075C57.3417 14.4392 58.5253 15.1881 59.5508 16.1542V11.6667C59.5508 9.46167 58.7881 7.59639 57.2625 6.07083C55.7369 4.54528 53.8717 3.7825 51.6667 3.7825H11.6667C9.46167 3.7825 7.59639 4.54528 6.07083 6.07083C4.54528 7.59639 3.7825 9.46167 3.7825 11.6667V16.1542C4.80806 15.1881 5.99167 14.4392 7.33333 13.9075C8.675 13.3753 10.1194 13.1092 11.6667 13.1092ZM3.90417 23.4483L43.3017 32.9675C43.6689 33.0575 44.0556 33.0661 44.4617 32.9933C44.8678 32.9206 45.1989 32.7453 45.455 32.4675L58.7567 21.3008C58.12 19.9808 57.1681 18.9158 55.9008 18.1058C54.6336 17.2958 53.2222 16.8908 51.6667 16.8908H11.6667C9.72222 16.8908 8.02139 17.5147 6.56417 18.7625C5.10695 20.0103 4.22028 21.5722 3.90417 23.4483Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader heading={"Så mycket tjänar vi"} text={subText} />
        <div ref={ref}>
          {municipality1 ? (
            <>
              <FiguresWrapper 
                style={{
                  marginBottom: "48px"
                }}
              >
                {municipality1 ? (
                  <SvgLayout width="47%">
                    <HeadingMunicipality
                      marginBottom="24px"
                      aria-label={ariaLabel(municipality1)}
                    >
                      {municipality1.name}
                    </HeadingMunicipality>
                    <SvgLayout ariaHidden={true}>
                      <AnimatedDiv
                        inView={inView}
                      >
                        <div>{municipality1 ? Number(municipality1.values.slice(-1).pop()).toLocaleString('sv-SE') : 0}</div>
                        <div className="label">kronor</div>
                      </AnimatedDiv>
                    </SvgLayout>
                  </SvgLayout>
                ) : (
                  <div></div>
                )}
                {municipality2 ? (
                  <SvgLayout width="47%">
                    <HeadingMunicipality
                      marginBottom="24px"
                      color={secondaryColor}
                      aria-label={ariaLabel(municipality2)}
                    >
                      {municipality2.name}
                    </HeadingMunicipality>
                    <SvgLayout ariaHidden={true}>
                      <AnimatedDiv
                        inView={inView}
                        style={{
                          color: secondaryColor,
                        }}
                      >
                        <div>{municipality2 ? Number(municipality2.values.slice(-1).pop()).toLocaleString('sv-SE') : 0}</div>
                        <div className="label">kronor</div>
                      </AnimatedDiv>
                    </SvgLayout>
                  </SvgLayout>
                ) : (
                  <SvgLayout width="50%">
                    <EmptySpace scroll={scroll} />
                  </SvgLayout>
                )}
              </FiguresWrapper>
              <SvgLayout
                ariaLabel={`Det här linjediagramet visar inkomstförändring före skatt i ${
                  municipality1.name
                } kommun ${
                  municipality2 ? "och " + municipality2.name + "kommun" : ""
                } `}
                useTabIndex
              >
                <Wrapper>
                  <HighLineChartLine
                    data={data}
                    startpoint={1991}
                    triggerAnimation={inView}
                  />
                </Wrapper>
              </SvgLayout>
            </>
          ) : null}
        </div>
      </BlockLayout>
    </React.Fragment>
  );
};

export default IncomeContainer;
